import React from 'react'

export default function Pagination({
  data: { first, last, index, pageCount, pathPrefix },
}) {
  if (pageCount === 1) {
    return null
  }
  return (
    <ul className="pagination">
      <li className={first ? 'disabled' : 'waves-effect'}>
        <a
          href={
            first
              ? '#'
              : index === 2 ? `/${pathPrefix}` : `/${pathPrefix}/${index - 1}`
          }
        >
          <i className="fa fa-chevron-left" />
        </a>
      </li>
      {Array(pageCount)
        .fill(0)
        .map((_, i) => i + 1)
        .map(idx => (
          <li className={idx === index ? 'active' : 'waves-effect'} key={idx}>
            <a href={idx === 1 ? `/${pathPrefix}` : `/${pathPrefix}/${idx}`}>
              {idx}
            </a>
          </li>
        ))}
      <li className={last ? 'disabled' : 'waves-effect'}>
        <a href={last ? '#' : `/${pathPrefix}/${index + 1}`}>
          <i className="fa fa-chevron-right" />
        </a>
      </li>
    </ul>
  )
}



// WEBPACK FOOTER //
// ./src/components/Pagination.js